<template>
  <button class="btn-yellow1 btn-yellow" @click="showPage2">Install To See More</button>
</template>

<script>
export default {
  props: ['position'],
  methods: {
    showPage2 () {
      console.log(this.$store.state.split)
      if (this.$store.state.split === '1') {
         location.href = 'http://rec.4funvideo.com/activity/4fun.apk'
         return;
      }
      // 上报
      this.$store.dispatch('report')

      window._czc.push(['_trackEvent', 'gpBtnClick', this.position]);

      setTimeout(() => {
        this.$store.dispatch('setPage', 2)
      }, 50);
      setTimeout(() => {
        location.href = this.$store.state.buttonUrl
      }, 300);
    }
  }
}
</script>
<style lang="scss">
.btn-yellow1 {
  width: 302px;
  animation: scaleAnimate 1.5s ease-in-out infinite;
}
</style>
